import { ApiService, UploadUrlsRequestTypeEnum } from 'js/src/client';
import { getGlobalUploadNetworkManager } from 'js/src/libs/upload-network-manager';

export function uploadVideoPoster(file: File, upload_url: string) {
    const uploadNetworkManager = getGlobalUploadNetworkManager();
    return uploadNetworkManager.queueTask(async () => {
        const uploadResult = await fetch(upload_url, {
            method: 'PUT',
            body: file,
        });

        if (!uploadResult.ok) {
            throw new Error(`Poster upload to GCS failed: ${uploadResult.statusText}`);
        }
    });
}

export async function uploadVideoPosterBlob(
    blob: Blob | null,
    fileName: string,
    fileType: string,
    videoId: number,
) {
    if (!blob) {
        return;
    }
    try {
        const file = new File([blob], fileName, { type: fileType });
        const response = await ApiService.uploadUrlsCreate({
            body: {
                type: UploadUrlsRequestTypeEnum.SINGLE_REQUEST_UPLOAD,
                file_name: file.name,
            },
        });
        // The bucket and file_name come from the upload-urls response, NOT from parsing
        // upload_url: the same-origin upload path rewrites that URL onto the app host,
        // so its host is the app domain rather than the bucket.
        const { upload_url, bucket, file_name } = response.data;
        await uploadVideoPoster(file, upload_url);
        await ApiService.videoPosterValidationUpdate({
            body: { bucket, file_name, video_id: videoId },
        });
    } catch (e: unknown) {
        // don't notify users of this error
    }
}
